
export const isIos = (): boolean => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
};
// Detects if device is in standalone mode
export const isInStandaloneMode = (): boolean =>
    ('standalone' in window.navigator) && ((window.navigator as any).standalone);
